module.exports = __webpack_public_path__ + "img/tuolele-default.13f78e68.png";